import { api_url } from "../../../utils";

const ParadasBusBuffer = {
    enable: true,
    checked: false,
    initialDisplay: false,
    excludeCities: [],
    source: "api",
    url: api_url + "maps/geojson/?table=bus_stops_buffer&schema_city=",
    zindex: 1,
    type: "single",
    popup: {
        default: {
            content: {
                es: {},
            },
            separators: {
                decimal: [],
                thousand: [],
            },
        },
    },
    titleSideBar: "Mobility Indicators Content.layers.ParadasBusBuffer",
    style: {
        regular: false,
        fillColor: "rgb(179, 181, 182)",
        strokeColor: "rgb(35, 35, 35)",
        strokeWidth: 0.7,
        strokeLineDash: [],
        points: 0,
        radius: 0,
        angle: 0,
        rotation: 0,
    },
    legend: {
        default: {
            title: "Mobility Indicators Content.layersLegend.ParadasBusBuffer.title",
            subtitle: "",
            attribute: "",
            symbol: "rectangle",
            legendCustomCssClass: "map-legend-symbol-border-1px-gray-35-35-35",
            class: [
                {
                    fillColor: "rgb(179, 181, 182)",
                    strokeColor: "rgb(35, 35, 35)",
                    strokeWidth: 0,
                    label: "Mobility Indicators Content.layersLegend.ParadasBusBuffer.classes.1",
                },
            ],
        },
    },
};

export default ParadasBusBuffer;
